<template>
    <!-- v-if="showLoginBox" -->
    <div class="login-component" v-if="showLoginBox" @click.self="closeLoginBox">
        <div class="login-form-box">
            <div class="close-login-form-box" @click="closeLoginBox"></div>
            <div class="login-bg">
                <div class="text-bg"></div>
            </div>
            <div class="form-box">
                <el-tabs v-model="activeName">
                    <!-- 账号密码登陆表单开始 -->
                    <el-tab-pane label="账号密码登录" name="first">
                        <el-form :model="passWordForm" status-icon :rules="rules" ref="passWordForm" class="login-ruleForm">
                            <div class="input-label"><img src="../assets/correcting-img/form-icon/phone.png" alt=""><span>手机号</span></div>
                            <el-form-item prop="phone">
                                <el-input type="text" v-model="passWordForm.phone" autocomplete="off" ref="pwLoginPhoneInput" placeholder="请输入11位手机号" class="login-tel-input"></el-input>
                            </el-form-item>
                            <div class="input-label"><img src="../assets/correcting-img/form-icon/password.png" alt=""><span>密码</span></div>
                            <el-form-item prop="password">
                                <el-input type="password" v-model="passWordForm.password" autocomplete="off" placeholder="请输入密码" @keyup.enter.native="submitForm('passWordForm')"></el-input>
                            </el-form-item>
                            <el-form-item class="Pw-submitBtnPw">
                                <el-button type="primary" @click="submitForm('passWordForm')" :loading="pwLoginBtnLoading">登录</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 账号密码登录表单结束 -->
                    <!-- 验证码登录/注册表单开始 -->
                    <el-tab-pane label="验证码登录/注册" name="second">
                        <el-form :model="identCodeForm" status-icon :rules="rules" ref="identCodeForm" class="login-ruleForm identcode-ruleForm">
                            <div class="input-label"><img src="../assets/correcting-img/form-icon/phone.png" alt=""><span>手机号</span></div>
                            <el-form-item prop="phoneNum">
                                <el-input type="text" v-model="identCodeForm.phoneNum" autocomplete="off" ref="identCodePhoneInput" placeholder="请输入11位手机号" class="login-tel-input"></el-input>
                            </el-form-item>
                            <div class="input-label"><img src="../assets/correcting-img/form-icon/identcode.png" alt=""><span>验证码</span></div>
                            <el-form-item prop="identcode">
                                <el-input type="text" v-model="identCodeForm.identcode" autocomplete="off" placeholder="请输入验证码" class="identcode-input" @keyup.enter.native="submitForm('identCodeForm')"></el-input>
                                <el-button plain :disabled="identCodeDisabled" @click="getIdentCode"><span v-if="reIndentCodeText">重新</span>获取验证码<span v-if="reIndentCodeNum">{{countdown}}</span></el-button>
                            </el-form-item>
                            <el-form-item class="IdentCode-submitBtn">
                                <el-button type="primary" @click="submitForm('identCodeForm')" :loading="indentCodeLoginBtnLoading">登录</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <!-- 验证码登录/注册表单结束 -->
                </el-tabs>
                <div class="third-login-box">
                    <div class="third-login-btn">
                        <span class="label">第三方账号登陆</span>
                        <span class="qq-login" @click="toQQLogin"></span>
                        <span class="wx-login" @click="toWxLogin"></span>
                    </div>
                    <div class="password-reset" @click="toPwReset">忘记密码</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Axios from '@/api/Axios'
import {SetCookie} from '@/api/cookie'
export default {
    name:"LoginBox",
    props:["isShowFormBox"],
    data(){
        let checkPassWord = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        let checkPwPhone = (rule, value, callback) => {
            let reg = /^1[0-9]{10}$/
            if (value === '') {
                callback(new Error('手机号码不能为空'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else if(this.message===0){
                callback(new Error('该手机号未注册'));
            } 
            else {
                callback();
            }
        };
        let checkIdentCode = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入验证码'));
            }else {
                callback();
            }
        };
        let checkIdentCodePhone = (rule, value, callback) => {
            let reg = /^1[0-9]{10}$/
            if (value === '') {
                callback(new Error('手机号码不能为空'));
                this.identCodeDisabled=true
            }else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
                this.identCodeDisabled=true
            }
            else {
                this.identCodeDisabled=false
                callback();
            }
        }
        return{
            showLoginBox:"",                   //控制登录弹窗显示隐藏
            activeName:"first",                //控制密码登陆验证码登陆选项卡
            qqLogin:true,                      //控制三方登陆按钮状态
            wxLogin:true,                      //控制微信三方登陆按钮状态
            identCodeDisabled:true,            //控制获取验证码按钮防重复点击
            reIndentCodeText:false,            //显示重新获取验证码文字
            reIndentCodeNum:false,             //显示重新获取验证码倒计时数字
            countdown:30,                      //重新获取验证码倒计时
            pwLoginBtnLoading:false,           //控制密码登陆表单按钮Loading状态
            indentCodeLoginBtnLoading:false,   //控制验证码登陆表单按钮Loading状态
            loginOrRegister:"",                //储存手机号注册状态 注册过在获取验证码时携带login参数 未注册携带register
            passWordForm:{                     //手机号密码登陆表单数据
                phone:'',
                password: ''
            },
            identCodeForm:{
                phoneNum:'',
                identcode: ''
            },
            rules: {                            //储存表单输入框验证
                password: [
                    { validator: checkPassWord, trigger: 'blur' }
                ],
                phone: [
                    { validator: checkPwPhone, trigger: 'blur' }
                ],
                phoneNum: [
                    { validator: checkIdentCodePhone, trigger: 'blur' }
                ],
                identcode:[
                    { validator: checkIdentCode, trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        //关闭登录弹窗
        closeLoginBox(){
            //向父组件传参改变父组件showLoginBox的值
            this.$emit("closeLogin",false)
            this.$emit("showPwReset",false)
            this.showLoginBox=false
        },
        //切换到忘记密码弹窗
        toPwReset(){
            this.$emit("closeLogin",false)
            this.$emit("showPwReset",true)
        },
        //三方登录QQ登录方法
        toQQLogin(){
            window.open("https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101827335&redirect_uri=https%3a%2f%2fadmin.beimen.com%2fqq%2fcallback&state=STATE#qq_redirect","_self")
        },
        //三方登录微信登录方法
        toWxLogin(){
            window.open("https://open.weixin.qq.com/connect/qrconnect?appid=wx0108b96741547f02&redirect_uri=http%3a%2f%2fadmin.beimen.com%2fwx%2fcallback&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect","_self")
        },
        //获取验证码方法
        getIdentCode(){
            if(this.loginOrRegister=="register"){
                Axios.post("sendsms",{"phone":this.identCodeForm.phoneNum,"register":1}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.identCodeDisabled=true;
                            this.reIndentCodeText=true;
                            this.reIndentCodeNum=true;
                            this.timer=setInterval(()=>{
                                this.countdown-=1;
                            },1000)
                        }
                    },
                    error=>{
                        console.log(error);
                        this.$message({
                            message: '出错了 请稍后重试',
                            type: 'error',
                            center:true,
                            offset:100,
                            duration:900
                        });
                    }
                )
            }else if(this.loginOrRegister=="login"){
                Axios.post("sendsms",{"phone":this.identCodeForm.phoneNum,"login":1}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.identCodeDisabled=true;
                            this.reIndentCodeText=true;
                            this.reIndentCodeNum=true;
                            this.timer=setInterval(()=>{
                                this.countdown-=1;
                            },1000)
                        }
                    },
                    error=>{
                        console.log(error);
                        this.$message({
                            message: '出错了 请稍后重试',
                            type: 'error',
                            center:true,
                            offset:100,
                            duration:900
                        });
                    }
                )
            }
        },
        //点击登录提交登陆表单
        submitForm(formName){
            //密码登陆表单接口调用
            if(formName=="passWordForm"){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        this.pwLoginBtnLoading=true
                        Axios.post('login',{"phone":this.passWordForm.phone,"password":this.passWordForm.password}).then(
                            response=>{
                                if(response.data.data.errCode==1002&&response.data.code==200){
                                    this.pwLoginBtnLoading=false
                                    this.$message.error({
                                        message: '账号或密码错误',
                                        type: 'error',
                                        center:true,
                                        offset:100,
                                        duration:900
                                        
                                    });
                                }else{
                                    this.pwLoginBtnLoading=false
                                    this.$message.success({
                                        message: '登录成功',
                                        type: 'success',
                                        center:true,
                                        offset:100,
                                        duration:900
                                    });
                                    //向父组件传递参数关闭登录、注册弹窗
                                    this.$emit("loginSuccess",true)
                                    this.$emit("closeLogin",false)
                                    this.$emit("showPwReset",false)
                                    //登录成功恢复登陆按钮可点击状态
                                    this.pwLoginBtnLoading=false
                                    SetCookie('token',response.data.data.token)
                                    SetCookie('phone',response.data.data.phone)
                                    SetCookie('real_auth',response.data.data.real_name_auth)
                                    SetCookie('v',response.data.data.white_info.is_vip)
                                }
                            },
                            error=>{
                                console.log(error)
                                this.pwLoginBtnLoading=false
                                this.$message.error({
                                    message: '出错了  请稍后重试',
                                    type: 'error',
                                    center:true,
                                    offset:100,
                                    duration:900
                                })
                            }
                        )
                    }
                })
            }
            //验证码登录注册接口调用
            else if(formName=="identCodeForm"){
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        //通过验证让登陆按钮进入LOADING不可点击状态
                        this.indentCodeLoginBtnLoading=true
                        Axios.post('login',{"phone":this.identCodeForm.phoneNum,"code":this.identCodeForm.identcode}).then(
                            response=>{
                                if(response.data.data.errcode==1000&&response.data.code==200){
                                    this.indentCodeLoginBtnLoading=false
                                    this.$message.error({
                                        message:'验证码错误',
                                        type:'error',
                                        center:true,  
                                        offset:100,
                                        duration:900
                                    });
                                }else if(response.data.data.errcode==1001&&response.data.code==200){
                                    this.indentCodeLoginBtnLoading=false
                                    this.$message.error({
                                        message:'验证码错误',
                                        type:'error',
                                        center:true,  
                                        offset:100,
                                        duration:900
                                    });
                                }else{
                                    this.$message.success({
                                        message: '登录成功',
                                        type: 'success',
                                        center:true,
                                        offset:100,
                                        duration:900
                                    });
                                    //向父组件传递参数关闭登录、注册弹窗
                                    this.$emit("loginSuccess",true)
                                    this.$emit("closeLogin",false)
                                    this.$emit("showPwReset",false)
                                    //登录成功恢复登陆按钮可点击状态
                                    this.indentCodeLoginBtnLoading=false
                                    SetCookie('token',response.data.data.token)
                                    SetCookie('phone',response.data.data.phone)
                                    SetCookie('real_auth',response.data.data.real_name_auth)
                                    SetCookie('v',response.data.data.white_info.is_vip)
                                }
                            },
                            error=>{
                                console.log(error)
                                this.indentCodeLoginBtnLoading=false
                                this.$message.error({
                                    message: '出错了  请稍后重试',
                                    type: 'error',
                                    center:true,
                                    offset:100,
                                    duration:900
                                })
                            }
                        )
                    }
                })
            }
        }
    },
    watch:{
        //监听手机号输至11位时验证该手机号是否注册
        "passWordForm.phone":function(){
            if(this.passWordForm.phone.length===11){
                Axios.get('/phone/info',{"phone":this.passWordForm.phone}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.message=response.data.data;
                            if(response.data.data===0){
                                this.$refs.pwLoginPhoneInput.blur()
                            }
                            if(response.data.data===1){
                                this.$refs.pwLoginPhoneInput.blur()
                            }
                        }
                    }
                )
            }
        },
        "identCodeForm.phoneNum":function(){
            if(this.identCodeForm.phoneNum.length===11){
                Axios.get('/phone/info',{"phone":this.identCodeForm.phoneNum}).then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            if(response.data.data===0){
                                this.loginOrRegister="register"
                                this.$refs.identCodePhoneInput.blur()
                            }
                            if(response.data.data===1){
                                this.loginOrRegister="login"
                                this.$refs.identCodePhoneInput.blur()
                            }
                        }
                    }
                )
            }
        },
        //监听重新获取验证码倒计时
        countdown:function(){
            if(this.countdown<=0){
                clearInterval(this.timer);
                this.reIndentCodeNum=false;
                this.identCodeDisabled=false;
                this.countdown=30;
            }
        },
        //监听点击了登陆按钮或切换回登陆实践
        isShowFormBox(){
            this.showLoginBox=this.isShowFormBox
            this.activeName="first"
        }
    }
}
</script>
<style lang="scss">
//重置elementUI表单和选项卡样式结束
.login-component{
    width:100%;
    height:100%;
    position:fixed;
    left:0;
    top:0;
    z-index:1000;
    background-color:rgba(0,0,0,.6);
    //重置elementUI表单和选项卡样式开始
    .el-tabs__item{
        color:#999 !important;
        font-size:18px !important;
        height:50px !important;
        font-weight:550 !important;
    }
    .el-tabs__item.is-active{
        color:#222 !important;
    }
    .el-tabs__nav-wrap::after{
        height:1px !important;
    }
    .el-tabs__active-bar{
        background-color:#bf0000 !important;
    }
    .close-login-form-box{
        width:32px;
        height:32px;
        background:url('../assets/correcting-img/close.png') no-repeat;
        background-size:cover;
        position:absolute;
        top:0;
        right:-50px;
        cursor:pointer;
    }
    .close-login-form-box:hover{
        opacity:.8;
    }
}
.login-form-box{
    position:absolute;
    width:776px;
    height:566px;
    background:#fff;
    border-radius:10px;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    display:flex;
    display:-webkit-flex;
    .el-form-item{
        margin-bottom:28px;
    }
    .login-bg{
        width:280px;
        min-height:500px;
        background:url('../assets/correcting-img/login-bg.png') no-repeat;
        background-size:100% 100%;
        position:relative;
        .text-bg{
            width:166px;
            height:248px;
            background:url('../assets/correcting-img/login-logo.png') no-repeat;
            background-size:100% 100%;
            position:absolute;
            top:20%;
            left:50%;
            transform:translateX(-50%);
        }
    }
    .form-box{
        width:496px;
        padding:40px 50px;
        min-height:500px;
        .el-form-item__content{
            height:60px !important;
        }
        .input-label{
            height:22px;
            font-size:16px;
            color:#222;
            font-weight:bold;
            margin-top:14px;
            img,span{
                vertical-align:top;
            }
            img{
                margin-right:10px;
            }
        }
        .el-form-item__error{
            padding-left:26px !important;
        }
        .login-ruleForm{
            overflow:hidden;
        }
        .login-ruleForm input{
            border:none;
            border-bottom:1px solid #e6e6e6;
            font-size:16px;
            color:#7E7E7E;
            padding:20px 0;
            height:60px;
            width:370px;
            float:right;
            border-radius:0;
        }
        .login-ruleForm input::-webkit-input-placeholder{
            color:#ccc;
        }
        .login-ruleForm input::-moz-input-placeholder{
            color:#ccc;
        }
        .login-ruleForm input::-ms-input-placeholder{
            color:#ccc;
        }
        .Pw-submitBtnPw,.IdentCode-submitBtn{
            button{
                width:370px !important;
                height:50px;
                float:right;
                font-size:18px;
                letter-spacing:4px;
                margin-top:10px;
                background:#bd0003;
                border-radius:10px;
            }
            button:hover{
                background:#de7f81 !important;
                border:none;
            }
        }
        .third-login-box{
            width:370px !important;
            float:right;
            display:flex;
            display:-webkit-flex;
            justify-content:space-between;
            font-size:16px;
            color:#999;
            .third-login-btn{
                width:200px;
                display:flex;
                display:-webkit-flex;
                justify-content:space-between;
                align-items:center;
            }
            .qq-login,.wx-login{
                display:inline-block;
                width:34px;
                height:34px;
                cursor:pointer;
            }
            .qq-login{
                background:url('../assets/correcting-img/form-icon/qqb.png') no-repeat;
            }
            .qq-login:hover{
                background:url('../assets/correcting-img/form-icon/qq.png') no-repeat !important;
            }
            .wx-login{
                background:url('../assets/correcting-img/form-icon/wxb.png') no-repeat;
            }
            .wx-login:hover{
                background:url('../assets/correcting-img/form-icon/wx.png') no-repeat !important;
            }
            .password-reset{
                cursor:pointer;
                height:34px;
                line-height:34px;
            }
            .password-reset:hover{
                opacity:0.8;
            }
        }
    }
    //验证码登录表单部分样式重置
    .identcode-ruleForm{
        .el-button.is-plain{
            background-color:#fff !important;
            font-size:16px !important;
            position:absolute;
            right:0px;
            color:#BF0000;
            border:none !important;
            height:40px;
            top:50%;
            transform: translateY(-50%);
        }
        .el-button.is-disabled{
            background-color:#fff !important;
            font-size:16px !important;
            position:absolute;
            right:0px;
            color:#ccc !important;
            border:none !important;
            height:40px;
            top:50%;
            transform: translateY(-50%);
        }
    }
}
</style>